import axios from 'axios'
import API_URL from '@/router/api'

export const getListSchoolDistrict = (ctx, params) => {
    return new Promise((resolve, reject) => {
        axios.get(API_URL.schoolDistrict.findMany, { params })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const getSchoolDistrict = (ctx, id) => {
    return new Promise((resolve, reject) => {
        axios.get(API_URL.schoolDistrict.findById.replace(/__id__/, id))
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                console.log({ err });
                reject(err)
            })
    })
}

export const getListSchoolBySchoolDistrict = (ctx, { id, params }) => {
    return new Promise((resolve, reject) => {
        axios.get(API_URL.schoolDistrict.findManyByDistrict.replace(/__id__/, id), { params })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const createSchoolDistrict = (ctx, form) => {
    return new Promise((resolve, reject) => {
        axios.post(API_URL.schoolDistrict.create, form)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const updateSchoolDistrict = (ctx, { id, name, org_no, country }) => {
    return new Promise((resolve, reject) => {
        axios.put(API_URL.schoolDistrict.update.replace(/__id__/, id), { name, org_no, country })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const deleteSchoolDistrict = (ctx, id) => {
    return new Promise((resolve, reject) => {
        axios.delete(API_URL.schoolDistrict.delete.replace(/__id__/, id))
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}
